import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from "@apollo/client";
import Uid2Token from "@/lib/uid2Token";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type HowtoPlay @cacheControl(maxAge: 60) {\n    id: ID!\n    free: Boolean\n    member_only: Boolean\n    rights: [Right]\n    courses: [Course]\n    products: [Product]\n  }\n\n  type Uid2Token {\n    token: String\n  }\n\n  type Query {\n    howtoPlay(id: Int): HowtoPlay\n    uid2Token: Uid2Token\n  }\n"])));
export var resolvers = {
  Query: {
    howtoPlay: function () {
      var _howtoPlay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var id, dataSources, res, meta, howtoplay, courses, rightIds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref.id;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.episodes.getEpisode(id);

              case 5:
                res = _context.sent;
                meta = res.metas[0];

                if (meta) {
                  _context.next = 9;
                  break;
                }

                throw new Error("not episode meta. ID: ".concat(id));

              case 9:
                _context.next = 11;
                return dataSources.meta.howtoPlay(id);

              case 11:
                howtoplay = _context.sent;
                courses = howtoplay.courses;
                rightIds = [];
                courses === null || courses === void 0 ? void 0 : courses.forEach(function (e) {
                  var value = e === null || e === void 0 ? void 0 : e.ref_id;

                  if (value) {
                    rightIds.push("ref:".concat(value));
                  }
                });
                return _context.abrupt("return", _objectSpread({
                  id: id
                }, howtoplay));

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);
                return _context.abrupt("return", null);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 18]]);
      }));

      function howtoPlay(_x, _x2, _x3) {
        return _howtoPlay.apply(this, arguments);
      }

      return howtoPlay;
    }(),
    uid2Token: function () {
      var _uid2Token = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _args, _ref3) {
        var req, res, uid2, token;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = _ref3.req, res = _ref3.res;
                uid2 = new Uid2Token(req, res);
                _context2.prev = 2;
                _context2.next = 5;
                return uid2.getToken();

              case 5:
                token = _context2.sent;
                return _context2.abrupt("return", {
                  token: token
                });

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                return _context2.abrupt("return", null);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      function uid2Token(_x4, _x5, _x6) {
        return _uid2Token.apply(this, arguments);
      }

      return uid2Token;
    }()
  }
};